.bottomSheet :global(.rc-drawer-content-wrapper) {
  border-radius: 24px 24px 0 0;
  left: 0;
  overflow: hidden;
  right: 0;
}

.bottomSheet :global(.rc-drawer-section) {
  --bottom-sheet-safe-area: env(safe-area-inset-bottom);

  max-height: 90dvh;
  padding-bottom: var(--bottom-sheet-safe-area);
}

.bottomSheet__undimmed :global(.rc-drawer-mask) {
  background: transparent;
}

/* Without the dim, a shadow keeps the sheet's edge visible on white pages. */
.bottomSheet__undimmed :global(.rc-drawer-content-wrapper) {
  box-shadow: var(--shadows-hard);
}

.handle {
  background-color: var(--colors-grays-light);
  border-radius: 2px;
  height: 4px;
  margin: 8px auto 0;
  width: 36px;
}
